// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeFiltersInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for the employee deductions / advances list endpoints.
 *
 * All filters are optional query params. The controller builds the model
 * filter array conditionally (only including non-empty values), and the models
 * cast/escape each value, so these are kept as raw nullable strings to preserve
 * the legacy `$this->input->get(...)` behavior.
 *
 * Shared by:
 * - GET /payroll/employee_deductions
 * - GET /payroll/employee_advances
 */
import { registerContract } from './validate'

export interface Payroll_EmployeeFiltersInput {
franchise_id?: string
employee_id?: string
status?: string
date_from?: string
date_to?: string
open_or_partial?: string
}

registerContract('Payroll_EmployeeFiltersInput', {
  franchise_id:    { type: 'string',  required: false },
  employee_id:     { type: 'string',  required: false },
  status:          { type: 'string',  required: false },
  date_from:       { type: 'string',  required: false },
  date_to:         { type: 'string',  required: false },
  open_or_partial: { type: 'string',  required: false },
})
